import { cardTypeParser } from './cardTypeParser';
import { AllMarketTypes } from '../enums';

export const toTwoBetTypeType = (cardNumber) => {
  switch (cardNumber) {
    case cardTypeParser(17):
    case cardTypeParser(18):
    case cardTypeParser(19):
    case cardTypeParser(20):
      return AllMarketTypes.J_Q;
    case cardTypeParser(21):
    case cardTypeParser(22):
    case cardTypeParser(23):
    case cardTypeParser(24):
      return AllMarketTypes.K_A;
    default:
      return null;
  }
};
